import React from 'react'

const user_profile = () => {
  return (
    <div>user_profile</div>
  )
}

export default user_profile